import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../app_config.js";
import "./css/App.css";

function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userId, recoveryId } = location.state;

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [countdown, setCountdown] = useState(null);

  const handleReset = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMessage("Passwörter stimmen nicht überein");
      setIsError(true);
      return;
    }

    const response = await fetch(`${API_BASE_URL}/api/resetPassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        recoveryId,
        password,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      setMessage(data.message);
      setIsError(false);
      setCountdown(5);

      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate("/login");
            return null;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      setMessage(data.message || "Fehler beim Ändern des Passworts");
      setIsError(true);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Neues Passwort setzen</h1>

        <form onSubmit={handleReset}>
          <div className="form-group">
            <label>Neues Passwort</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Passwort bestätigen</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <div className="nav">
            <button type="submit">Passwort ändern</button>
          </div>

          {message && (
            <div className={isError ? "error-message" : "success-message"}>
              <p>{message}</p>
              {countdown && <p>Umleitung zur Login-Seite in {countdown}s...</p>}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
